import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/Utility.css';

const utilityData = [
  {
    title: '🧠 AI Arsenal Access',
    content: [
      "All holders receive instant access to Dark chain legion’s AI generation suite—designed for both warriors and creators. Create high-fidelity images, animated clips, or lore-based prompts.",
      "Future updates will unlock:",
      "🖼️ Text-to-image with faction styles",
      "🎬 AI-assisted teaser/trailer generation",
      "📜 Lore-to-comic storytelling (experimental)",
      "⚙️ Trait-based output customization"
    ]
  },
  {
    title: '📖 Lore-Gated Gameplay',
    content: [
      "Each NFT is a gateway into Dark chain legion’s evolving story. Holders write, shape, and vote on major lore arcs. Based on your warrior’s metadata, you may unlock:",
      "• Faction quests and secret missions",
      "• Community co-authorship and PvE voting rights",
      "• In-game item drops tied to lore involvement"
    ]
  },
  {
    title: '🎁 Relic Airdrops & Trait Evolution',
    content: [
      "Long-term holders and stakers are rewarded with Relics—algorithmic NFT extensions that evolve your character. Relics can provide:",
      "🔥 Visual upgrades (onchain mutations)",
      "🧬 Metadata-altering artifacts",
      "💡 Access to advanced AI features"
    ]
  },
  {
    title: '📦 Darkchain Treasury',
    content: [
      "50% of mint revenue is staked in the Darkchain DAO wallet.",
      "Decisions on future development, game mechanics, lore alliances, and AI tooling are driven by the community. Your NFT is your voice."
    ]
  },
  {
    title: '🚀 Faction-Based Expansion',
    content: [
      "Collaborations with other chains and NFT projects will introduce faction-based quests and cross-collection rewards. Possibilities include:",
      "🎯 Dynamic role badges based on cross-chain activity",
      "📬 Priority whitelist access for allied drops"
    ]
  },
  {
    title: '🎮 Game Integration (Stretch Goal)',
    content: [
      "A tactical, lore-infused browser game is in early prototyping—where your NFT acts as a digital avatar. PvP zones, resource staking, and Darkchain missions await."
    ]
  }
];

function Utility() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <motion.div
      className="utility-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <h1>UTILITY: Unlock the Power of the Legion</h1>
      <p>
        Dark chain legion is not just a collection—it’s a key to power within a broken metaverse.
        Every NFT is a living relic, granting its holder access to tools, lore, decisions, and territory
        within the evolving Darkchain ecosystem.
      </p>

      <div className="utility-steps">
        {utilityData.map((item, index) => (
          <div key={index} className="utility-step">
            <div className="utility-header" onClick={() => toggleIndex(index)}>
              <span>{item.title}</span>
              <span className="icon">{openIndex === index ? '−' : '+'}</span>
            </div>

            <AnimatePresence initial={false}>
              {openIndex === index && (
                <motion.div
                  className="utility-body"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4, ease: 'easeInOut' }}
                >
                  {item.content.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>

      <p>
        <strong>Dark chain legion is not passive art. It’s living tech. It’s your relic of power.</strong>
      </p>
    </motion.div>
  );
}

export default Utility;
